import { Radio } from '@mui/material'
import React from 'react'

/**
 * Single radio field
 * @param props 
 * @returns 
 */

function CouponRadioField(props:any) {
  const {label , description, checked,value,handleChange,name} = props

  return (
    <div className={`coupon-radio-field-wrapper ${checked?'coupon-radio-field-checked':''}`} onClick={(e)=>handleChange(value)}>
      <div className={`coupon-radio-field-header-wrapper ${checked?'coupon-radio-field-checked':''}`}>
        <Radio checked={checked} onChange={()=>handleChange(value)} value={value} name={name} style={{padding:0}} 
        sx={{
          color:'var(--dashboard-secondary-color)',
          '&.Mui-checked': {
            color: 'var(--dashboard-secondary-color)',
          },
        }}
        />
        <span className={`coupon-radio-field-header-text ${checked?'coupon-radio-field-checked':''}`}>{label}</span>
      </div>
      {
        description && 
        <div className="coupon-radio-field-description-wrapper">
          <p>{description}</p>
        </div>
      }
    </div>
  )
}

export default CouponRadioField